module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_3009.1f15d875.png";